import React from "react";
import dummyImage from "./dummy.jpg"
import { IconButton, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

const styles = {
  container: {
    display: 'inline-flex',
    borderRadius: 10,
    border: '1px solid #E6E6E6',
    marginBottom: 8,
    marginRight: 8,
    width: 250,
    height: 200,
    padding: 4,
    boxSizing: 'border-box',
    position: "relative",
    wordBreak: "break-word"
  },
  inner: {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    cursor: "pointer",
    width: '100%',
    height: '100%',
    borderRadius: 2,
    border: '1px solid #E6E6E6',
  },
  img: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }
};

const Thumbnail = ({ url, visualName, type = "image" }) => {
  const isImage = type === "image";
  const isVideo = type === "video";
  const validUrl = url && url.trim() !== "";

  return (
    <div style={styles.container}>
      <Stack direction={"column"} spacing={1}>
        <div style={styles.inner}>
          {isImage && (
            <img
              src={validUrl ? url : dummyImage}
              style={styles.img}
              alt="Click for Preview"
              title="Click for Preview"
            />
          )}
          {isVideo && validUrl ? (
            <video
              width="100%"
              height="100%"
              alt="Click for Preview"
              title="Click for Preview"
              controls
              muted
              src={url}
            />
          ) : null}
        </div>
        <Typography variant="body2" sx={{ padding: "2px" }}>{visualName}</Typography>
      </Stack>


    </div>
  );
};

export default Thumbnail;
